import React from 'react';
import './addcta.css'
import pic52 from '../../assets/pic52.png'

const SaveCTA = (props) => {
    return ( 
        <button className='cta-event' type="button"           onClick={props.onClick}   >
                <img src={pic52} alt='add icon' className='iconnnn-addd-cta'></img>
                <h2 className='cta-event-text'>{props.title}</h2>
        </button>
     );
}
 
export default SaveCTA;